<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $t("fnbWastage") }}
      </div>
      <router-link class="btn-blue" to="fnb-wastage"
        >{{ $t("fnbWastage") }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="edit-movie-container">
      <form class="row">
        <!-- CINEMAS SELECTION -->
        <div class="col-md-3 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in cinemas"
                  :key="cinemaIndex"
                  href="#"
                  @click="onSelectCinema(cinema)"
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('fnbwastage_selectcinema')" /> -->
            </div>
            <p
              v-if="submitted && selectedCinema.length == 0"
              class="error_message"
            >
              Please Select Cinema.
            </p>
          </div>
        </div>

        <!-- SELECTED CONCESSION -->
        <!-- <div class="col-md-3 mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="selectedConcession.length > 0 ? 'shift-up' : '' "
            >{{ $t('select') }} {{ $t('concession') }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown :text="selectedConcession" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(Item,ItemIndex) in concessionLevels"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectConcessionLevel(Item)"
                >{{ Item.cl_name }}</b-dropdown-item>
              </b-dropdown>
              <Tooltip :title="$t('fnbwastage_selectconcession')" />
            </div>
            <p
              v-if="submitted && selectedConcession.length == 0"
              class="error_message"
            >Please Select Concession.</p>
          </div>
        </div>-->

        <!-- STORE LEVEL -->
        <div class="col-md-3 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedStoreLevel.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $t("sm_store_name") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedStoreLevel"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Item, ItemIndex) in storeManagementsLevels"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectStoreLevel(Item)"
                  >{{ Item.sm_store_name }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('fnbwastage_selectconcession')" /> -->
            </div>
            <p
              v-if="submitted && selectedStoreLevel.length == 0"
              class="error_message"
            >
              Please Select Store Level.
            </p>
          </div>
        </div>

        <!-- STORE LEVEL -->
        <!-- <div v-if="finalStoreLevel.length > 0" class="col-md-3 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedFinalStore.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $t("sm_store_name") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedFinalStore"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Item, ItemIndex) in finalStoreLevel"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectStoreLevel(Item)"
                  >{{ Item.sm_store_name }}</b-dropdown-item
                >
              </b-dropdown>
              <Tooltip :title="$t('fnbwastage_selectconcession')" />
            </div>
            <p
              v-if="submitted && selectedFinalStore.length == 0"
              class="error_message"
            >
              Please Select Store Level.
            </p>
          </div>
        </div> -->

        <div class="col-md-3 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="fnb_wastage.fw_date"
                  v-on:click="cleardoj()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="fnb_wastage.fw_date"
                  name="fromd"
                  id="fromd"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label
                  :class="
                    typeof fnb_wastage.fw_date === 'object' ? 'active' : ''
                  "
                  >Date</label
                >
              </div>
            </div>
            <!-- <Tooltip :title="$t('fnbwastage_fromdate')" /> -->
          </div>
          <p v-if="submitted && errors.has('fromd')" class="error_message">
            {{ errors.first("fromd") }}
          </p>
        </div>

        <div class="col-md-3 mb-4 align-items-center d-flex">
          <div class="d-flex align-items-center">
            <b-form-radio
              :value="'N'"
              class="j-radio"
              @change="onChangeWastageType($event)"
              v-model="fnb_wastage.is_item"
            >
              <div>
                <span>{{ "Raw Materail" }}</span>
              </div>
            </b-form-radio>
            <strong class="mx-3">OR</strong>

            <b-form-radio
              :value="'Y'"
              class="j-radio"
              @change="onChangeWastageType($event)"
              v-model="fnb_wastage.is_item"
            >
              <div>
                <span>{{ "Prepared Item" }}</span>
              </div>
            </b-form-radio>
          </div>
        </div>

        <template v-if="fnb_wastage.is_item == 'N'">
          <div class="col-md-3 mb-4">
            <div class="dropdown-curve-container">
              <label :class="selectedRawMaterial.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("rawmaterials", 2) }}</label
              >
              <div class="d-flex justify-content-center align-items-center">
                <b-dropdown
                  :text="selectedRawMaterial"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Raw Material"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchRawMaterial()"
                      v-on:keydown="onSearchRawMaterial()"
                      v-on:search="onSearchRawMaterial()"
                      v-model="searchRawMaterial"
                    />
                  </div>
                  <b-dropdown-item
                    v-for="(Item, ItemIndex) in rawMaterials"
                    :key="ItemIndex"
                    href="#"
                    @click="onSelectRawMaterial(Item)"
                    >{{ Item.rm_name }}</b-dropdown-item
                  >
                </b-dropdown>
                <!-- <Tooltip :title="$t('fnbwastage_rawmaterials')" /> -->
              </div>
              <p
                v-if="submitted && selectedRawMaterial.length == 0"
                class="error_message"
              >
                Please Select Raw Material.
              </p>
            </div>
          </div>

          <div class="col-md-3 mb-4">
            <div class="dropdown-curve-container">
              <label :class="selectedUoM.length > 0 ? 'shift-up' : ''">{{
                $tc("unitofmeasurement", 2)
              }}</label>
              <div class="d-flex justify-content-center align-items-center">
                <b-dropdown
                  :text="selectedUoM"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-for="(Item, ItemIndex) in UoMList"
                    :key="ItemIndex"
                    href="#"
                    @click="onSelectUom(Item)"
                    >{{ Item.uom_unit }}</b-dropdown-item
                  >
                </b-dropdown>
                <!-- <Tooltip :title="$t('fnbwastage_selectunitofmeasurements')" /> -->
              </div>
              <p
                v-if="submitted && selectedUoM.length == 0"
                class="error_message"
              >
                Please Select Unit of Measurement.
              </p>
            </div>
          </div>

          <div class="col-md-3 mb-4">
            <div class="dropdown-curve-container">
              <!-- <label
              :class="selectedQuantity.length > 0 ? 'shift-up' : '' "
            >{{ $t('select') }} {{ $tc('quantity', 2) }}</label>-->
              <div class="d-flex justify-content-center align-items-center">
                <!-- <b-dropdown :text="selectedQuantity" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(Item,ItemIndex) in 20"
                  :key="ItemIndex"
                  href="#"
                  @click="selectedQuantity = String(Item);fnb_wastage.fw_quantity=Item"
                >{{ Item }}</b-dropdown-item>
              </b-dropdown>-->
                <!-- <b-input-group> -->
                <div class="input-material">
                  <input
                    v-model="fnb_wastage.fw_quantity"
                    style="
                      height: 40px;
                      border-top-left-radius: 10px;
                      border-bottom-left-radius: 10px;
                    "
                    type="text"
                    placeholder="."
                    name="wastage_qty"
                    id="wastage_qty"
                    v-validate="'required|decimal'"
                    v-on:keyup="calculatemaxqty($event.target.value)"
                  />

                  <label
                    :class="
                      fnb_wastage.fw_quantityy &&
                      String(fnb_wastage.fw_quantity).length > 0
                        ? 'shift-up'
                        : ''
                    "
                    >{{ $t("quantity") }}</label
                  >
                </div>

                <!-- v-on:keyup="CalculateSelectedRawMaterial($event.target.value,vendorIndex)" -->

                <!-- <template v-slot:append>
                    <b-dropdown variant="dropdown-curve" class="w-100">
                      <b-dropdown-item
                        v-for="(loop , key) in 20"
                        :key="key"
                        v-on:click="onSelectQuantity(loop)"
                      >{{loop}}</b-dropdown-item>
                    </b-dropdown>
                  </template>
              </b-input-group>-->
                <!-- <Tooltip :title="$t('fnbwastage_selectquantity')" /> -->
              </div>
              <span v-if="max_qty && selectedUoM"
                >Max Quantity : ({{
                  max_qty ? max_qty + " " + this.selectedUoM : ""
                }})</span
              >
              <p
                v-if="submitted && errors.has('wastage_qty')"
                class="error_message"
              >
                {{ errors.first("wastage_qty") }}
              </p>
            </div>
          </div>

          <!-- TOTAL AMOUNT -->
          <div class="col-md-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  v-model="fnb_wastage.fw_fine_amount"
                  name="fineamount"
                  id="fineamount"
                  v-validate="'required|decimal'"
                />
                <label>{{ $tc("totalamount", 2) }}</label>
              </div>
              <!-- <Tooltip :title="$t('fnbwastage_fireamount')" /> -->
            </div>
            <p
              v-if="submitted && errors.has('fineamount')"
              class="error_message"
            >
              {{ errors.first("fineamount") }}
            </p>
          </div>
        </template>

        <template v-else>
          <div class="col-md-3 mb-4 d-flex">
            <div class="dropdown-curve-container">
              <multiselect
                class="selectCinemaDandD"
                v-model="selectedFnbItem"
                :options="fnbItemsArray"
                :placeholder="''"
                @select="onSelectFnbItems($event, 'select')"
                @remove="onSelectFnbItems($event, 'remove')"
                label="item_name"
                track-by="item_id"
                selectLabel="Select"
                deselectLabel="✖"
                :multiple="false"
              ></multiselect>
              <label :class="selectedFnbItem ? 'shift-up' : ''">
                {{ $tc("Fnb Item", 2) }}
              </label>
            </div>
            <!-- <Tooltip :title="'Add Prepared Item as Wastage'" /> -->
          </div>

          <div class="col-md-3 mb-4">
            <div class="dropdown-curve-container">
              <div class="d-flex justify-content-center align-items-center">
                <div class="input-material">
                  <input
                    v-model="fnb_wastage.fw_quantity"
                    style="
                      height: 40px;
                      border-top-left-radius: 10px;
                      border-bottom-left-radius: 10px;
                    "
                    type="text"
                    placeholder="."
                    name="wastage_qty"
                    id="wastage_qty"
                    v-validate="'required|decimal'"
                    v-on:keyup="calculateFnbWastage($event.target.value)"
                  />

                  <label
                    :class="
                      fnb_wastage.fw_quantityy &&
                      String(fnb_wastage.fw_quantity).length > 0
                        ? 'shift-up'
                        : ''
                    "
                    >{{ $t("quantity") }}</label
                  >
                </div>

                <!-- <Tooltip :title="$t('fnbwastage_selectquantity')" /> -->
              </div>
              <span v-if="max_qty && selectedUoM"
                >Max Quantity : ({{
                  max_qty ? max_qty + " " + this.selectedUoM : ""
                }})</span
              >
              <p
                v-if="submitted && errors.has('wastage_qty')"
                class="error_message"
              >
                {{ errors.first("wastage_qty") }}
              </p>
            </div>
          </div>

          <!-- TOTAL AMOUNT -->
          <div class="col-md-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  v-model="fnb_wastage.fw_fine_amount"
                  name="fineamount"
                  id="fineamount"
                  v-validate="'required|decimal'"
                />
                <label>{{ $tc("totalamount", 2) }}</label>
              </div>
              <!-- <Tooltip :title="$t('fnbwastage_fireamount')" /> -->
            </div>
            <p
              v-if="submitted && errors.has('fineamount')"
              class="error_message"
            >
              {{ errors.first("fineamount") }}
            </p>
          </div>
        </template>

        <!-- <div class="col-md-6 mb-4">
          <div class>
            <label>{{ $t('select') }} {{ $tc('quantity', 2) }}</label>
          </div>
          <div class>
            <b-dropdown :text="selectedQuantity" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(Item,ItemIndex) in 20"
                :key="ItemIndex"
                href="#"
                @click="selectedQuantity = Item;fnb_wastage.fw_quantity=Item"
              >{{ Item }}</b-dropdown-item>
            </b-dropdown>
          </div>
          <p
            v-if="submitted && selectedQuantity == 'Select Quantity'"
            class="error_message"
          >Please Select Quantity.</p>
        </div>-->

        <div class="col-md-3 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedApprovedUser.length > 0 ? 'shift-up' : ''">{{
              $t("approvedby")
            }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedApprovedUser"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search User"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchApprovedBy()"
                    v-on:keydown="onSearchApprovedBy()"
                    v-on:search="onSearchApprovedBy()"
                    v-model="searchApprovedBy"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Item, ItemIndex) in userListFiltered"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectApprovedByUser(Item)"
                  >{{
                    Item.first_name +
                    (Item.last_name ? " " + Item.last_name : "")
                  }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('fnbwastage_approvedby')" /> -->
            </div>
            <p
              v-if="submitted && selectedApprovedUser.length == 0"
              class="error_message"
            >
              Please Select Approved By.
            </p>
          </div>
        </div>

        <div class="col-md-3 mb-4 d-none">
          <div class="dropdown-curve-container">
            <label
              :class="selectedAccountableUser.length > 0 ? 'shift-up' : ''"
              >{{ $t("accountableuser") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedAccountableUser"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    autofocus
                    type="search"
                    placeholder="Search User"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchUser()"
                    v-on:keydown="onSearchUser()"
                    v-on:search="onSearchUser()"
                    v-model="searchUser"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Item, ItemIndex) in accountableUserListFiltered"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectAccountableUser(Item)"
                  >{{
                    Item.first_name +
                    (Item.last_name ? " " + Item.last_name : "")
                  }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('fnbwastage_accountableuser')" /> -->
            </div>
            <p
              v-if="submitted && selectedAccountableUser.length == 0"
              class="error_message"
            >
              Please Select Account able User.
            </p>
          </div>
        </div>

        <!-- <div class="col-md-6 mb-4">
          <div class>
            <label>{{ $t('approvedby') }}</label>
          </div>
          <div class>
            <b-dropdown :text="selectedApprovedUser" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(Item,ItemIndex) in users"
                :key="ItemIndex"
                href="#"
                @click="onSelectApprovedByUser(Item)"
              >{{ Item.first_name }}</b-dropdown-item>
            </b-dropdown>
          </div>
          <p
            v-if="submitted && selectedApprovedUser == 'Approved By'"
            class="error_message"
          >Please Select Approved By.</p>
        </div>-->

        <!-- AMOUNT -->
        <div class="col-md-3 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="fnb_wastage.fw_reason"
                name="remark"
                id="remark"
                v-validate="'required'"
              />
              <label>{{ $tc("remark", 2) }}</label>
            </div>
            <!-- <Tooltip :title="$t('fnbwastage_reasons')" /> -->
          </div>
          <p v-if="submitted && errors.has('remark')" class="error_message">
            {{ errors.first("remark") }}
          </p>
        </div>

        <!-- <div class="col-md-6 mb-4">
          <label>{{ $tc('reason', 2) }}</label>
          <div class="d-flex align-items-center">
            <div class="input-material">
                <input placeholder="."
                type="text"
                v-model="fnb_wastage.fw_reason"
                name="reason"
                id="reason"
                v-validate="'required|alpha_spaces'"
              />
            </div>
            <Tooltip :title="$t('tooltip')" />
          </div>
          <p
            v-if="submitted && errors.has('reason')"
            class="error_message"
          >{{ errors.first('reason') }}</p>
        </div>-->

        <!-- <div class="col-md-6 mb-4">
          <label>{{ $tc('fineamount', 2) }}</label>
          <div class="d-flex align-items-center">
            <div class="input-material">
                <input placeholder="."
                type="text"
                v-model="fnb_wastage.fw_fine_amount"
                name="fineamount"
                id="fineamount"
                v-validate="'required|numeric'"
              />
            </div>
            <Tooltip :title="$t('tooltip')" />
          </div>
          <p
            v-if="submitted && errors.has('fineamount')"
            class="error_message"
          >{{ errors.first('fineamount') }}</p>
        </div>-->

        <!-- FNB PRICE FROM DATE -->

        <!-- IS ACTIVE -->
        <div class="col-md-4 mb-4 d-flex align-items-center">
          <label class="mt-2">{{ $t("active") }}</label>
          <div class="d-flex align-items-center ml-2">
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="fnb_wastage.fw_is_active"
              type="checkbox"
              class="j-checkbox"
              checked
            />
            <!-- <span class="switch-slider"></span>
            </label> -->
          </div>
        </div>

        <b-modal ref="my-modal" hide-footer title>
          <div class="d-block text-center">
            <h5>Do you want to add wastage ?</h5>
          </div>
          <div class="col-md-12 text-center mt-4">
            <button
              :disabled="btnDisabled"
              :class="btnDisabled ? 'btnDis' : ''"
              @click="onFinalSubmit(finalFlag)"
              class="btn-blue"
            >
              Yes
            </button>

            <button @click="hideModal" class="btn-blue">No</button>
          </div>
        </b-modal>
        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="fnb-wastage"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import PosFnbService from "@/services/PosFnbService.js";
import MasterService from "@/services/MasterService.js";
import signageServices from "@/services/signageService.js";

export default {
  data() {
    return {
      fnbItemsArray: [],
      selectedFnbItem: "",
      btnDisabled: false,
      usersCopy: [],
      searchApprovedBy: "",
      accountableUsersCopy: [],
      searchUser: "",
      rawMaterialsCopy: [],
      searchRawMaterial: "",
      max_qty: null,
      cinemasCopy: [],
      searchCinema: "",
      btenable: false,
      isRoleID: true,
      submitted: false,
      fnb_wastage: {
        item_id: null,
        item_name: "",
        is_item: "N",
        cinema_id: "",
        concession_level_id: "",
        sm_id: "",
        rm_id: "",
        fw_quantity: "",
        uom_id: "",
        fw_reason: "",
        // fw_accountable_user_id: "",
        fw_is_approved: "",
        fw_approved_by: "",
        fw_fine_amount: "",
        fw_date: new Date(),
        fw_is_active: true,
      },
      cinemas: [],
      concessionLevels: [],
      storeManagementsLevels: [],
      finalStoreLevel: [],
      AllfinalStoreLevel: [],
      rawMaterials: [],
      UoMList: [],
      accountableUsers: [],
      users: [],
      selectedCinema: "",
      selectedConcession: "",
      selectedStoreLevel: "",
      selectedFinalStore: "",
      selectedRawMaterial: "",
      selectedQuantity: "",
      selectedUoM: "",
      selectedAccountableUser: "",
      selectedApprovedUser: "",
      UnitMeasurement: [],
      RawmaterialPrice: [],
      final_qty: "",
      finalFlag: false,
      showOverlap: false,
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemas(obj);
  },
  mounted() {
    // this.getRawMaterials();
    // this.getConcessionLevels();
    // this.getUomList();
    this.getUser();
  },
  computed: {
    userListFiltered() {
      let arr = [];
      if (this.fnb_wastage.cinema_id) {
        arr = this.users.filter(
          (x) => x.cinema_id == this.fnb_wastage.cinema_id || !x.cinema_id
        );
      }
      console.log("userListFiltered", arr);
      return arr;
    },
    accountableUserListFiltered() {
      let arr = [];
      if (this.fnb_wastage.cinema_id) {
        arr = this.accountableUsers.filter(
          (x) => x.cinema_id == this.fnb_wastage.cinema_id || !x.cinema_id
        );
      }
      console.log("accountableUserListFiltered", arr);
      return arr;
    },
  },
  methods: {
    onChangeWastageType(event) {
      console.log("Event onChangeWastageType", event);
      let tempObj = {
        item_id: null,
        item_name: "",
        rm_id: "",
        fw_quantity: "",
        uom_id: "",
        fw_fine_amount: "",
      };

      Object.keys(tempObj).map((key) => {
        this.fnb_wastage[key] = tempObj[key];
      });

      this.selectedRawMaterial = "";
      this.selectedFnbItem = "";
    },
    calculateFnbWastage(value) {
      this.fnb_wastage.fw_quantity = value;
      let finalAmount = 0;
      let singleAmount = 0;
      if (this.selectedFnbItem) {
        singleAmount = +parseFloat(
          this.selectedFnbItem["itc_cost_price"] || 0
        ).toFixed(this.MIN_FRACTION_DIGITS);
      }
      finalAmount =
        singleAmount *
        +parseFloat(this.fnb_wastage.fw_quantity || 0).toFixed(this.MIN_FRACTION_DIGITS);
      console.log(finalAmount, "finalAmount");
      this.fnb_wastage.fw_fine_amount = parseFloat(finalAmount).toFixed(this.MIN_FRACTION_DIGITS);
    },
    onSelectFnbItems(event, type) {
      if (type == "remove") {
        this.fnb_wastage.item_id = null;
        this.fnb_wastage.item_name = "";
      } else {
        if (event.recipe_id) {
          this.fnb_wastage.item_id = event.item_id;
          this.fnb_wastage.item_name = event.item_name;
        } else {
          this.fnb_wastage.item_id = null;
          this.fnb_wastage.item_name = "";
          this.selectedFnbItem = "";
          this.$toasted.show("Recipe Not Found. Please Try Another Item.");
          this.$forceUpdate();
        }
      }
    },
    cleardoj() {
      this.fnb_wastage.fw_date = "";
    },
    GetFnbItems: function (cinema_id) {
      this.fnbItemsArray = [];

      let payload = {
        cinema_id: cinema_id,
      };

      signageServices
        .GetFnBListSignages(payload)
        .then((response) => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              this.fnbItemsArray = data.Records.filter(
                (x) => x.is_combo == "N"
              );
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSearchApprovedBy: function () {
      if (this.searchApprovedBy && this.searchApprovedBy.length > 0) {
        this.users = this.usersCopy.filter((x) => {
          // let full_name = `${x.first_name} ${x.last_name}`
          if (
            x.first_name
              .toLowerCase()
              .includes(this.searchApprovedBy.toLowerCase())
            // x.last_name.toLowerCase().includes(this.searchUser.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.users = this.usersCopy;
      }
    },
    onSearchUser: function () {
      if (this.searchUser && this.searchUser.length > 0) {
        this.accountableUsers = this.accountableUsersCopy.filter((x) => {
          // let full_name = `${x.first_name} ${x.last_name}`
          if (
            x.first_name.toLowerCase().includes(this.searchUser.toLowerCase())
            // x.last_name.toLowerCase().includes(this.searchUser.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.accountableUsers = this.accountableUsersCopy;
      }
    },
    onSearchRawMaterial: function () {
      if (this.searchRawMaterial && this.searchRawMaterial.length > 0) {
        this.rawMaterials = this.rawMaterialsCopy.filter((x) => {
          if (
            x.rm_name
              .toLowerCase()
              .includes(this.searchRawMaterial.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.rawMaterials = this.rawMaterialsCopy;
      }
    },
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.cinemas = this.cinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.cinemas = this.cinemasCopy;
      }
    },
    onSelectQuantity: function (params) {
      // this.selectedQuantity = params.toString();
      this.fnb_wastage.fw_quantity = params;
    },
    getUser: function () {
      let payload = {
        tableName: "users",
        is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // let filteredUsers = data.Records.filter((x) =>
            //   [4,8].includes(x.role_id)
            // );

            this.users = data.Records.filter((x) =>
              ["1", "2", "3"].includes(String(x.role_id))
            );
            this.usersCopy = data.Records.filter((x) =>
              ["1", "2", "3"].includes(String(x.role_id))
            );

            this.accountableUsers = data.Records.filter((x) =>
              ["4", "8"].includes(String(x.role_id))
            );
            this.accountableUsersCopy = data.Records.filter((x) =>
              ["4", "8"].includes(String(x.role_id))
            );
            // preselect logged in user
            let user_id = this.secureStore.get("USINFO").user_id;
            let userObj = this.accountableUsers.find(
              (x) => x.user_id == user_id
            );
            if (userObj) {
              this.onSelectAccountableUser(userObj);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getRawMaterials: function (store) {
      this.rawMaterials = [];
      this.rawMaterialsCopy = [];
      this.selectedRawMaterial = "";

      let payload = {
        sm_id: store.sm_id,
        cinema_id:this.fnb_wastage.cinema_id
      };
      PosFnbService.GetStoreBasedQuantity(payload)
        .then((response) => {
          const { data } = response;
          if (
            data &&
            data.status &&
            data.Records.length > 0 &&
            data.Records.filter((x) => parseInt(x.final_stock_quantity) > 0)
              .length > 0
          ) {
            this.rawMaterials = data.Records.filter(
              (x) => parseInt(x.final_stock_quantity) > 0
            );
            this.rawMaterialsCopy = data.Records.filter(
              (x) => parseInt(x.final_stock_quantity) > 0
            );
          } else {
            this.$toasted.show("No Raw Material Fetched");
          }
        })
        .catch(this._CatchError); //message
    },
    getCinemas: function (cine_id) {
      // let payload = {
      //   tableName: "ms_cinemas"
      // };
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.cinemas = data.Records;
            this.cinemasCopy = data.Records;
            this.cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selectedCinema = x.cine_name;
                this.onSelectCinema(x);
              }
            });
          } else {
            // this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getStoreManagementLevel: function (cinema_id) {
      this.storeManagementsLevels = [];
      this.selectedStoreLevel = "";
      // let payload = {
      //   tableName: "store_management",
      //   sm_is_active: "Y",
      //   cinema_id: cinema_id
      //   // sm_parent_id: 0
      // };
      MasterService.GetStoreManagement({ cine_id: cinema_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.storeManagementsLevels = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getConcessionLevels: function (cinema_id) {
      this.concessionLevels = [];
      this.selectedConcession = "";
      // let payload = {
      //   tableName: "ms_concession_levels",
      //   cl_is_active: "Y",
      //   cinema_id: cinema_id
      // };
      MasterService.GetConcessionByCinema({ cine_id: cinema_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.concessionLevels = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    calculatemaxqty: function (value) {
      if (value > this.max_qty) {
        this.fnb_wastage.fw_quantity = this.max_qty;
        this.$toasted.show("Max Quantity can be " + this.max_qty);
      } else {
        this.fnb_wastage.fw_quantity = value;
      }

      let amount = this.RawmaterialPrice[0].conversion_rate
        ? this.RawmaterialPrice[0].conversion_rate
        : this.RawmaterialPrice[0].singleRate;
      let filter2 = this.UnitMeasurement.filter((x) => {
        return x.conversion_from == this.fnb_wastage.uom_id;
      });

      let finalAmount = 0;

      if (filter2.length > 0) {
        finalAmount =
          amount * this.fnb_wastage.fw_quantity * filter2[0].conversion_formula;
      } else {
        finalAmount = amount * this.fnb_wastage.fw_quantity;
      }
      console.log(finalAmount);
      this.fnb_wastage.fw_fine_amount = parseFloat(finalAmount).toFixed(this.MIN_FRACTION_DIGITS);
    },
    onSelectCinema: function (cinema) {
      this.selectedCinema = cinema.cine_name;
      this.fnb_wastage.cinema_id = cinema.cine_id;

      this.searchCinema = "";
      this.selectedConcession = "";
      this.selectedStoreLevel = "";
      this.selectedFinalStore = "";
      this.selectedRawMaterial = "";
      this.selectedQuantity = "";
      this.selectedUoM = "";
      this.onSearchCinema();
      // this.getConcessionLevels(cinema.cine_id);
      this.getStoreManagementLevel(cinema.cine_id);
      this.GetFnbItems(cinema.cine_id);
    },
    onSelectConcessionLevel: function (concession) {
      this.selectedConcession = concession.cl_name;
      this.fnb_wastage.concession_level_id = concession.cl_id;
    },

    onSelectMainStoreLevel: function (store) {
      this.selectedStoreLevel = store.sm_store_name;
      this.finalStoreLevel = [];
      this.selectedFinalStore = "";
      this.fnb_wastage.sm_id = null;
      this.selectedConcession = "";
      this.selectedRawMaterial = "";
      this.selectedQuantity = "";
      this.selectedUoM = "";
      // let payload = {
      //   cine_id: this.fnb_wastage.cinema_id,
      //   sm_parent_id: store.sm_id,
      // };
      // MasterService.GetStoreManagement(payload)
      //   .then((response) => {
      //     const { data } = response;
      //     if (data && data.status && data.Records.length > 0) {
      //       this.finalStoreLevel = data.Records;
      //     } else {
      //       this.$toasted.show("No Stores found at Level 2 or Level 3");
      //       this.fnb_wastage.sm_id = store.sm_id;
      //       this.getRawMaterials(store);
      //     }
      //   })
      //   .catch(this._CatchError); //message
    },

    onSelectStoreLevel: function (store) {
      this.selectedStoreLevel = store.sm_store_name;
      this.fnb_wastage.sm_id = store.sm_id;
      this.getRawMaterials(store);
    },

    onSelectRawMaterial: function (rawmaterial) {
      this.selectedRawMaterial = rawmaterial.rm_name;
      this.fnb_wastage.rm_id = rawmaterial.rm_id;
      this.max_qty = rawmaterial.final_stock_quantity;
      this.final_qty = rawmaterial.final_stock_quantity;
      console.log(this.max_qty);
      this.searchRawMaterial = "";
      this.selectedUoM = "";
      this.selectedQuantity = "";

      this.fnb_wastage.uom_id = null;
      this.onSearchRawMaterial();
      this.getRelatedUom(rawmaterial.rm_id);
    },

    getRelatedUom: function (rm_id) {
      let cinema_id = this.fnb_wastage.cinema_id;
      PosFnbService.getUomFromRawMaterial({ rm_id, cinema_id: cinema_id })
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.UoMList = data.Records;
            this.UnitMeasurement = data.UnitMeasurement;
            this.RawmaterialPrice = data.RawMaterialPrice;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },

    onSelectUom: function (uom) {
      this.selectedQuantity = "";
      this.fnb_wastage.fw_fine_amount = 0;
      this.fnb_wastage.fw_quantity = 0;
      let filter2 = this.UnitMeasurement.filter((x) => {
        return x.conversion_from == uom.uom_id;
      });

      if (filter2.length > 0) {
        console.log(this.max_qty, filter2[0].conversion_formula);
        this.max_qty = parseInt(this.final_qty / filter2[0].conversion_formula);
        console.log(this.max_qty, "fsdfds");
      } else {
        this.max_qty = this.final_qty;
      }
      this.selectedUoM = uom.uom_unit;
      this.fnb_wastage.uom_id = uom.uom_id;
    },

    onSelectAccountableUser: function (user) {
      this.selectedAccountableUser =
        user.first_name + (user.last_name ? " " + user.last_name : "");
      this.fnb_wastage.fw_accountable_user_id = user.user_id;
      this.searchUser = "";
      this.onSearchUser();
    },

    onSelectApprovedByUser: function (user) {
      this.selectedApprovedUser =
        user.first_name + (user.last_name ? " " + user.last_name : "");
      this.fnb_wastage.fw_approved_by = user.user_id;
      this.searchApprovedBy = "";
      this.onSearchApprovedBy();
    },

    onResetForm: function () {
      this.fnb_wastage = {
        cinema_id: "",
        concession_level_id: "",
        sm_id: "",
        rm_id: "",
        fw_quantity: "",
        uom_id: "",
        fw_reason: "",
        // fw_accountable_user_id: "",
        fw_is_approved: "",
        fw_approved_by: "",
        fw_fine_amount: "",
        fw_date: "",
        fw_is_active: true,
      };

      this.selectedFinalStore = "";
      this.selectedApprovedUser = "";
      this.selectedAccountableUser = "";
      this.selectedRawMaterial = "";
      this.selectedCinema = "";
      this.selectedConcession = "";
      this.selectedStoreLevel = "";
      // this.selectedQuantity = "";
      this.selectedUoM = "";
    },
    onSubmit(flag) {
      console.log("fsdfdsfdsfdsfs");
      // this.processing = false
      this.showOverlap = true;
      this.$refs["my-modal"].show();
      this.finalFlag = flag;
      // this.onFinalSubmit(this.finalFlag)
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },

    validateFinalForm(type = 2, showErrorMsg = true) {
      let errorCount = 0;
      let errorMsg = ``;
      let status = true;
      if (type == 2) {
        if (!this.fnb_wastage.cinema_id) {
          errorCount++;
          errorMsg = "Please Select Cinema";
        } else if (!this.fnb_wastage.item_id) {
          errorCount++;
          errorMsg = "Please Select Item";
        } else if (!this.fnb_wastage.fw_quantity) {
          errorCount++;
          errorMsg = "Please Select Qty.";
        } else if (this.selectedStoreLevel.length == 0) {
          errorCount++;
          errorMsg = "Please Select Store";
        } else if (
          this.selectedStoreLevel.length != 0 &&
          this.finalStoreLevel.length > 0 &&
          this.selectedFinalStore.length == 0
        ) {
          errorCount++;
          errorMsg = "Please Select Store";
        } else if (this.fnb_wastage.fw_approved_by.length == 0) {
          errorCount++;
          errorMsg = "Please Select Approved By User";
        } //else if (this.fnb_wastage.fw_accountable_user_id.length == 0) {
        //   errorCount++;
        //   errorMsg = "Please Select Accountable User";
        // }
      } else if (type == 1) {
      }

      if (errorCount > 0) {
        status = false;
        if (showErrorMsg) {
          this.$toasted.show(errorMsg);
        }
      } else {
        status = true;
      }

      return status;
    },

    onFinalSubmit: function (flag) {
      this.$refs["my-modal"].hide();
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (this.fnb_wastage.is_item == "N") {
          if (
            this.fnb_wastage.cinema_id.length == 0 ||
            this.selectedStoreLevel.length == 0 ||
            (this.selectedStoreLevel.length != 0 &&
              this.finalStoreLevel.length > 0 &&
              this.selectedFinalStore.length == 0) ||
            this.fnb_wastage.fw_approved_by.length == 0 ||
            this.fnb_wastage.rm_id.length == 0 ||
            this.fnb_wastage.uom_id.length == 0 // ||
            // this.fnb_wastage.fw_accountable_user_id.length == 0
          ) {
            return;
          }
          if (valid) {
            this.btenable = true;
            this.btnDisabled = true;
            let filter2 = this.UnitMeasurement.filter((x) => {
              return x.conversion_from == this.fnb_wastage.uom_id;
            });
            if (filter2.length > 0) {
              this.fnb_wastage["conversion_formula"] =
                filter2[0].conversion_formula;
            } else {
              this.fnb_wastage["conversion_formula"] = 1;
            }

            
            let payload = {
              ...this.fnb_wastage,
            };
            PosFnbService.AddFnbWastage(payload)
              .then((response) => {
                const { data } = response;
                if (data && data.status) {
                  this.$validator.reset();
                  this.onResetForm();
                  if (flag) {
                    this.$router.push({
                      path: "fnb-wastage",
                    });
                    this.$toasted.show(data.message);
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError)
              .finally(() => {
                this.btnDisabled = false;
                this.btenable = false;
              });
          }
        } else if (this.fnb_wastage.is_item == "Y") {
          if (
            this.fnb_wastage.cinema_id.length == 0 ||
            this.selectedStoreLevel.length == 0 ||
            (this.selectedStoreLevel.length != 0 &&
              this.finalStoreLevel.length > 0 &&
              this.selectedFinalStore.length == 0) ||
            this.fnb_wastage.fw_approved_by.length == 0 //||
            //this.fnb_wastage.fw_accountable_user_id.length == 0
          ) {
            return;
          }
          if (!this.validateFinalForm(2, true)) {
            return;
          } else if (valid) {
            let payload = {
              ...this.fnb_wastage,
            };
            PosFnbService.AddPreparedItemWastage(payload)
              .then((response) => {
                const { data } = response;
                if (data && data.status) {
                  this.$validator.reset();
                  this.onResetForm();
                  if (flag) {
                    this.$router.push({
                      path: "fnb-wastage",
                    });
                    this.$toasted.show(data.message);
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError);
          }
        }
      });
    },
  },
};
</script>

<style>
.btnDis {
  pointer-events: none;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FnbWastageComponents/addFnbWastage.vue